module.exports = __webpack_public_path__ + "img/doc-convert-to-webpage.2cbccb86.svg";